<div id="unauthorized-page-container">
    <div id="text-container">
        <h1 class="title">{{ 'unauthorizedPage.title' | translate }}</h1>

        <div class="content">
            <p>{{ 'unauthorizedPage.content.firstSentence' | translate }}</p>
            <p class="small-width">
                <span [innerHtml]="'unauthorizedPage.content.secondSentence' | translate"></span>
            </p>
        </div>

        <div class="action-buttons">
            <btn
                id="error-page-sign-out-btn"
                [label]="'unauthorizedPage.signOut.button.text'"
                [severity]="'primary'"
                [size]="'large'"
                (click)="logout()"></btn>
        </div>
    </div>

    <div id="image-container">
        <img src="images/illustrations/error_403.svg" alt="server-error-image" />
    </div>
</div>
